import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import type {GammaEffect, GammaEffectObject} from '@PosterWhiteboard/items/image-item/gamma-effect.class';
import {BaseGammaColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gamma-color-option';
import {GammaColorType} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gamma-option/base-gamma-option.types';

interface BaseGammaOptionProps {
  gamma: GammaEffect | GammaEffectObject;

  updateColor(color: GammaColorType, value: number, undoable?: boolean): void;

  onToggleGamma(): void;
}

export function BaseGammaOption({...props}: BaseGammaOptionProps): ReactElement<any> {
  const getValue = (color: GammaColorType): number => {
    switch (color) {
      case GammaColorType.BLUE:
        return props.gamma.blue;
      case GammaColorType.GREEN:
        return props.gamma.green;
      case GammaColorType.RED:
        return props.gamma.red;
      default:
        throw new Error('Unhandled gamma color type');
    }
  };

  const getSubOptions = (): Array<ReactElement<any>> | null => {
    if (!props.gamma.isEnabled) {
      return null;
    }
    return [GammaColorType.RED, GammaColorType.GREEN, GammaColorType.BLUE].map((option) => {
      return (
        <BaseGammaColorOption
          key={option}
          color={option}
          value={getValue(option)}
          updateColor={(color, value, undoable): void => {
            props.updateColor(color, value, undoable);
          }}
        />
      );
    });
  };

  return (
    <ContextualMenuToggleOption
      id="item-gamma-option"
      label={window.i18next.t('pmwjs_gamma')}
      isChecked={props.gamma.isEnabled}
      onClick={(): void => {
        props.onToggleGamma();
      }}
    >
      {getSubOptions()}
    </ContextualMenuToggleOption>
  );
}
